import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router';

import { PreInitLoading } from "../../components/auth";
import { getAuth0Client } from '../../services/auth0';



// ------------ login page
export const LoginPage = () => {
  const [redirectToHome, setRedirectToHome] = useState(false);

  useEffect(() => {
    (async () => {
      const auth0 = getAuth0Client();
      const isAuthenticated = await auth0.isAuthenticated();

      if (isAuthenticated) {
        setRedirectToHome(true);
      } else {
        await auth0.loginWithRedirect({
          authorizationParams: {
            redirect_uri: window.location.origin
          }
        });
      }
    })();
  }, []);

  if (redirectToHome) {
    return <Navigate to="/" replace />;
  }

  return <PreInitLoading />;
};


// ------------ logout page
export const LogoutPage = () => {
  const auth0Client = getAuth0Client();
  auth0Client.logout({
    logoutParams: {
      returnTo: window.location.origin
    }
  });
  return <PreInitLoading />;
};


